import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Icon from '../Icon';
import colors from '../Theme/colors';

const loadingPropertyTypes = {
  title: PropTypes.string.isRequired,
};

type LoadingProperties = InferProps<typeof loadingPropertyTypes> & {
  fill?: string;
};

const Loading = ({
  title,
  fill = colors.greyDark,
  ...properties
} : LoadingProperties) => (
  <Icon
    // eslint-disable-next-line max-len
    dPath="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
    title={title}
    fill={fill}
    className="loader"
    {...properties}
  />
);

Loading.propTypes = loadingPropertyTypes;

export default Loading;
